import { rehydrateAnimals } from "../store/animalsStore";
import { rehydratePayments } from "../store/paymentsStore";
import { rehydrateBankTransfers } from "./bankTransferStore";
import { rehydrateCustomers } from "../store/customersStore";
import { rehydrateDeliveryAssignments } from "./deliveryStore";
import { rehydrateSharePresales } from "./sharePresalesStore";

export async function refreshOperationalStores() {
  await Promise.all([
    rehydrateAnimals(),
    rehydratePayments(),
    rehydrateBankTransfers(),
    rehydrateCustomers(),
    rehydrateDeliveryAssignments(),
    rehydrateSharePresales(),
  ]);
}

export async function applyOperationResult(_result?: unknown) {
  await refreshOperationalStores();
}
